import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../helpers/breakpoints';

const StyledMain = styled.main`
  display: block;
  max-width: calc(${breakpoints.mw} - var(--gutter) * 2);
  margin: 0 auto;
  padding-left: var(--gutter);
  padding-right: var(--gutter);
`;

const Main = props => {
  const { as, children } = props;
  return <StyledMain as={as}>{children}</StyledMain>;
};

export default Main;
